(function () {
    'use strict';
    EO_PlSearchBoxController.$inject = ['$scope', '$attrs', '$element'];

    function EO_PlSearchBoxController($scope, $attrs, $element) {
//
        var $ctrl = this;


        onLoad();

        function onLoad() {
            if (!$ctrl.searchPlaceHolder)
                $ctrl.searchPlaceHolder = 'جستجو';
            if ($ctrl.canFilter === undefined)
                $ctrl.canFilter = false;
            if ($ctrl.filterCount === undefined)
                $ctrl.filterCount = 0;

        }

        $ctrl.search = function () {
            $ctrl.onSearch();
        }

        $ctrl.searchKeyPress = function (keyEvent) {
            if (keyEvent.which === 13) {
                $ctrl.search();
            }
        }

        $ctrl.clearSearch = function () {
            $ctrl.onClearSearch();
        }

        $ctrl.filterClick = function () {
            if ($ctrl.onFilterClick)
                $ctrl.onFilterClick();
        }

    }


    var EO_PlSearchBox = {
        // template:'tets:{{$ctrl.testStr}}',
        templateUrl: 'app/components/eyeson/pl-search-box/eyeson.pl-search-box.template.html',
        controller: EO_PlSearchBoxController,
        bindings: {

            'searchQuery': '=',
            'searchPlaceHolder': '=?',
            'onSearch': '&',
            'onClearSearch': '&',
            'canFilter': '=?',
            'onFilterClick': '=?',
            'filterCount': '=?'

        }


    };

    angular
        .module('tikonApp')
        .component('eoPlSearchBox', EO_PlSearchBox)


})();

